<template lang="pug">
    .graphic(ref="container")
        .image(v-if="src")
            figure(:style="{ width: `${width}px`, height: `${height}px` }")
                //- v-lazy="src"
                img(
                    :src="src.cdn"
                    :key="image.id"
                    :title="title"
                    :style="{ width: `${width}px`, height: `${height}px` }"
                    rel="noopener"
                )
            //- figcaption(v-if="title || subTitle")
            //-     p(v-if="title") {{ title }}
            //-     small(v-if="subTitle") {{ subTitle }}
</template>

<script>
export default {
    name: 'Graphic',
    props: {
        title: {
            type: String,
            required: true
        },
        image: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            maxW: undefined,
        }
    },
    computed: {
        width() {
            if (this.src.width && this.maxW) return _.min([this.src.width, this.maxW])
            else return undefined
        },
        height() {
            if (this.width && this.src.aspectRatio) return this.width / this.src.aspectRatio
            else return undefined
        },
        src() {
            const image = this.image

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            let maxH = window.innerHeight - 20
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                maxH = this.$refs.container.clientHeight
                maxH -= (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight))
            }
            height = Math.min(maxH, height)
            width = height * aspectRatio

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(maxH, image.height / fz)
                width = height * aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            return {
                cdn: image.url,
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}&format=webp`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
    },
    methods: {
        initialize() {
            const options = {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: true,
                aspectRatio: '9:16',
                autoplay: true,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216,
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true,
                },
                controlBar: {
                    pictureInPictureToggle: false,
                },
                // plugins: {
                //     hlsQualitySelector: {
                //         displayCurrentQuality: true,
                //     }
                // }
            };
            this.player = videojs(this.$refs.player, options);
            this.player.httpSourceSelector();

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            })
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>
    .graphic
        display: flex
        flex-grow: 1
        max-height: calc(100vh - 65px)
        justify-content: center
        align-items: center
</style>
